import { connect } from 'react-redux'
import SchoolSearch from './search'
import debounce from 'lodash/debounce'
import { searchSchool } from '../../redux/fsu-teacher.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapDispatchToProps = dispatch => ({
  onChange: debounce(
    value => dispatch(searchSchool(value)).catch(errorHandler),
    500
  )
})

export default connect(
  null,
  mapDispatchToProps
)(SchoolSearch)
